<template>
  <div
    v-show="favStore.totalCount"
    class="circle"
    :class="{ 'with-count': mounted && favStore.totalCount }"
  >
    <i v-if="mounted">{{ favStore.totalCount }}</i>
  </div>
</template>

<script setup lang="ts">
import { useFavouritesStore } from '~/stores/useFavouritesStore'

// Favourites store loads favourites onMounted so don't make any reactive
// updates in this component based on store updates until is is mounted
// otherwise we get hydration errros.
const favStore = useFavouritesStore(usePinia())
const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})
</script>

<style scoped>
.circle {
  align-items: center;
  background: var(--colour-light-green);
  border-radius: 99em;
  display: flex;
  justify-content: center;
  left: 2.1em;
  min-height: 0.75em;
  min-width: 0.75em;
  position: absolute;
  visibility: visible;
  z-index: 1;
}

.circle i {
  padding: 0 0.35em;
  font-size: 0.6em;
  font-weight: bold;
  font-style: normal;
  color: white;
}
</style>
